var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultipleChoice = function SvgMultipleChoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 16,
    viewBox: "0 0 25 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.368,
    height: 3.364,
    x: 7.934,
    y: 0.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.789,
    height: 3.364,
    x: 0.581,
    y: 0.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.368,
    height: 3.364,
    x: 7.934,
    y: 6.318,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.789,
    height: 3.364,
    x: 0.581,
    y: 6.318,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.368,
    height: 3.364,
    x: 7.934,
    y: 12.136,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.789,
    height: 3.364,
    x: 0.581,
    y: 12.136,
    rx: 1
  }))));
};
export default SvgMultipleChoice;